export default {
      id: "contact-usage",
      viewBox: "0 0 19 19",
      url: __webpack_public_path__ + "sprite.svg#contact",
      toString: function () {
        return this.url;
      }
    }